import React from "react";

import MainDetails from "./components/MainDetails";
import AddDetails from "./components/AddDetails";
import TransactionDate from "./components/TransactionDate";
import CreditsChange from "./components/CreditsChange";

import classes from "./styles.module.scss";

const isLegacyParametricUnlock = (transfer = {}, spent = {}) =>
    transfer.feature === "LEGACY_PARAMETRIC_UNLOCK" || spent.legacyCreditsSpent != null;

const TableRow = ({ transaction }) => {
    const {
        amountInCents = 0,
        createdAt: createdAtInSeconds = 0,
        receiptUrl = "",
        invoice = "in_1Rvmhp2YpVlxUt7bL5HBaaEu",
        spent = {},
        transactionType = "",
        transfer = {},
        credits = 0,
    } = transaction || {};

    const hideNewCreditDelta = isLegacyParametricUnlock(transfer, spent);

    return (
        <div className={classes.tableRowContainer}>
            <MainDetails
                receiptUrl={receiptUrl}
                transactionType={transactionType}
                amountInCents={amountInCents}
                invoice={invoice}
            />

            <AddDetails spent={spent} transfer={transfer} transactionType={transactionType} />
            <TransactionDate date={createdAtInSeconds} />
            {hideNewCreditDelta ? (
                <div />
            ) : (
                <CreditsChange
                    credits={credits}
                    isPositive={transactionType === "PURCHASED" || transactionType === "TRANSFER_IN"}
                />
            )}
        </div>
    );
};

export default TableRow;
